import script from "./update.vue?vue&type=script&setup=true&lang=js"
export * from "./update.vue?vue&type=script&setup=true&lang=js"

import "./update.vue?vue&type=style&index=0&id=3a8c1efd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.member/src/fe-member/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8c1efd"]])

export default __exports__